import * as Yup from "yup";
import { Formik } from "formik";
import { Button, Form } from "react-bootstrap";
import getOnboardingStages from "../../utils/onboardingStages";
import isFileSizeUnderLimit from "../../utils/fileUploadSize";
import Spinner from 'react-bootstrap/Spinner';
import { Flag } from "react-feather";

const { REACT_APP_BACKEND_URL } = process.env;


const OnboardingDocuments = ({stage, token, data}) => {
  let onboardingStages = getOnboardingStages(data.preferences);
  let colorPhotoRequired = data.preferences && data.preferences.colorPhotoRequired;
  let aclsRequired = data.preferences && data.preferences.aclsRequired;
  let cvRequired = data.preferences && data.preferences.cvRequired;
  let pastHospitalPrivilegesDocumentRequired = data.preferences && data.preferences.pastHospitalPrivilegesDocumentRequired;

  let hideOptionalDocumentFields = data.preferences && data.preferences.hideOptionalDocumentFields;

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        driversLicenseFilename: data.driversLicenseFilename == null ? "" : data.driversLicenseFilename,
        driversLicenseFile: null,
        driversLicenseBackFilename: data.driversLicenseBackFilename == null ? "" : data.driversLicenseBackFilename,
        driversLicenseBackFile: null,
        driversLicenseExpirationDate: data.driversLicenseExpirationDate == null ? "" : data.driversLicenseExpirationDate,
        aclsFilename: data.aclsFilename == null ? "" : data.aclsFilename,
        aclsFile: null,
        aclsExpirationDate: data.aclsExpirationDate == null ? "" : data.aclsExpirationDate,
        blsFilename: data.blsFilename == null ? "" : data.blsFilename,
        blsFile: null,
        blsExpirationDate: data.blsExpirationDate == null ? "" : data.blsExpirationDate,
        palsFilename: data.palsFilename == null ? "" : data.palsFilename,
        palsFile: null,
        palsExpirationDate: data.palsExpirationDate == null ? "" : data.palsExpirationDate,
        cdsFilename: data.cdsFilename == null ? "" : data.cdsFilename,
        cdsFile: null,
        cdsExpirationDate: data.cdsExpirationDate == null ? "" : data.cdsExpirationDate,
        cvFile: null,
        cvFilename: data.cvFilename == null ? "" : data.cvFilename,
        cvPhotoFile: null,
        colorPhotoFilename: data.colorPhotoFilename == null ? "" : data.colorPhotoFilename,
        colorPhotoFile: null,
        ecfmgFilename: data.ecfmgFilename == null ? "" : data.ecfmgFilename,
        ecfmgFile: null,
        pastHospitalPrivilegesDocumentFilename: data.pastHospitalPrivilegesDocumentFilename == null ? "" : data.pastHospitalPrivilegesDocumentFilename,
        pastHospitalPrivilegesDocumentFile: null,
        cmeFilenames: data.cmeFilenames == null ? "" : data.cmeFilenames,
        cmeFiles: null,
        otherCertificationsFilenames: data.otherCertificationsFilenames == null ? "" : data.otherCertificationsFilenames,
        otherCertificationsFiles: null
        
      }}
      validationSchema={Yup.object().shape({
        driversLicenseFilename: Yup.string(),
        driversLicenseFile: Yup.mixed().when("driversLicenseFilename", {
          is: value => !value || value === "",
          then: Yup.mixed().required("Government issued ID is required"),
          otherwise: Yup.mixed()
        })
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        driversLicenseBackFilename: Yup.string(),
        driversLicenseBackFile: Yup.mixed()
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        driversLicenseExpirationDate: Yup.date().required("Expiration date is required"),
        aclsFilename: Yup.string(),
        aclsFile: Yup.mixed().when("aclsFilename", {
          is: value => aclsRequired && (!value || value === ""),
          then: Yup.mixed().required("ACLS is required"),
          otherwise: Yup.mixed()
        })
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        blsFilename: Yup.string(),
        blsFile: Yup.mixed()
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        palsFilename: Yup.string(),
        palsFile: Yup.mixed()
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        cdsFilename: Yup.string(),
        cdsFile: Yup.mixed()
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        cvFilename: Yup.string(),
        cvFile: Yup.mixed().when("cvFilename", {
          is: value => cvRequired && (!value || value === ""),
          then: Yup.mixed().required("CV is required"),
          otherwise: Yup.mixed()
        })
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        colorPhotoFilename: Yup.string(),
        colorPhotoFile: Yup.mixed().when("colorPhotoFilename", {
          is: value => colorPhotoRequired && (!value || value === ""),
          then: Yup.mixed().required("Color photo is required"),
          otherwise: Yup.mixed()
        })
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        ecfmgFile: Yup.mixed()
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        pastHospitalPrivilegesDocumentFilename: Yup.string(),
        pastHospitalPrivilegesDocumentFile: Yup.mixed().when("pastHospitalPrivilegesDocumentFilename", {
          is: value => pastHospitalPrivilegesDocumentRequired && (!value || value === ""),
          then: Yup.mixed().required("Hospital Privileges document is required"),
          otherwise: Yup.mixed()
        })
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        otherCertificationsFiles: Yup.mixed()
        .test(
          "fileSize",
          "File size(s) too large; max total of 50MB",
          (files) => {
            var sum = 0;
            if (files) 
            {
              for (var i = 0; i < files.length; i++) {
                sum += files[i].size;
              }
              return sum <= (10485760 * 5);  /// Cap it at ~50MB total
              
            }
            return true;
          }
        ),
      })}
      onSubmit={async (values, { setErrors, setStatus, resetForm, setSubmitting }) => {
        try {
          var formData = new FormData();
          formData.append("data", new Blob([JSON.stringify(
            {
              driversLicenseExpirationDate: values.driversLicenseExpirationDate,
              aclsExpirationDate: values.aclsExpirationDate,
              blsExpirationDate: values.blsExpirationDate,
              palsExpirationDate: values.palsExpirationDate,
              cdsExpirationDate: values.cdsExpirationDate,
            })], {
              type: "application/json"
          }));

          if (values.driversLicenseFile)
          {
            formData.append("driversLicenseFile", values.driversLicenseFile);
          }
          if (values.driversLicenseBackFile)
          {
            formData.append("driversLicenseBackFile", values.driversLicenseBackFile);
          }
          if (values.aclsFile)
          {
            formData.append("aclsFile", values.aclsFile);
          }
          if (values.blsFile)
          {
            formData.append("blsFile", values.blsFile);
          }
          if (values.palsFile)
          {
            formData.append("palsFile", values.palsFile);
          }
          if (values.cdsFile)
          {
            formData.append("cdsFile", values.cdsFile);
          }
          if (values.cvFile)
          {
            formData.append("cvFile", values.cvFile);
          }
          if (values.colorPhotoFile)
          {
            formData.append("colorPhotoFile", values.colorPhotoFile);
          }
          if (values.ecfmgFile)
          {
            formData.append("ecfmgFile", values.ecfmgFile);
          }
          if (values.pastHospitalPrivilegesDocumentFile)
          {
            formData.append("pastHospitalPrivilegesDocumentFile", values.pastHospitalPrivilegesDocumentFile);
          }
          if (values.cmeFiles)
          {
            for (var i = 0; i < values.cmeFiles.length; i++) 
            {
              formData.append("cmeFiles", values.cmeFiles[i]);
            }
          }
          if (values.otherCertificationsFiles)
          {
            for (var i = 0; i < values.otherCertificationsFiles.length; i++) 
            {
              formData.append("otherCertificationsFiles", values.otherCertificationsFiles[i]);
            }
          }

          const requestMetadata = {
            method: 'POST',
            body: formData
          };

          const res = await fetch(REACT_APP_BACKEND_URL + "onboarding/" + stage + "/" + token, requestMetadata); 
          if (res.status >= 200 && res.status <= 299)
          {
            setStatus({success: true})

            window.location = "/onboarding/" + onboardingStages[onboardingStages.indexOf(stage) + 1] + "/" + token
          }
          else if (res.status === 400)
          {
            setStatus({ success: false });
            alert("Unable to submit; please disable any ad blockers and/or antivirus software and try again. If the problem persists, using a different browser may help.");
            setSubmitting(false);
          }
          else
          {
            throw Error(res.statusText);
          }
        } catch (error) {
          var message = "Something went wrong; please try again";

          if (error instanceof TypeError && error.message === "Failed to fetch")
          {
            message = "Please make sure that no files are open elsewhere on your computer, and then try again.";
          }

          setStatus({ success: false });
          alert(message);
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        status,
        touched,
        values,
        getFieldProps,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Documents</Form.Label>
            <br /><br />
            <Form.Label style={{fontWeight: "bold"}}>Government Issued ID (Front)*</Form.Label>
            <br />
            {values.driversLicenseFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.driversLicenseFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("driversLicenseFilename")}
            />
            <Form.Control
              type="file"
              name="driversLicenseFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("driversLicenseFile", file);
              }}
              isInvalid={Boolean(touched.driversLicenseFile && errors.driversLicenseFile)}
            />
            {!!touched.driversLicenseFile && (
              <Form.Control.Feedback type="invalid">
                {errors.driversLicenseFile}
              </Form.Control.Feedback>
            )}
            <br />
            <Form.Label style={{fontWeight: "bold"}}>Government Issued ID (Back)
            <br /><span style={{fontSize: '0.9em', fontWeight: "normal"}}><Flag style={{height: "16px", width: "16px", color: "#2B7A78"}} /> If applicable</span>
            </Form.Label>
            <br />
            {values.driversLicenseBackFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.driversLicenseBackFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("driversLicenseBackFilename")}
            />
            <Form.Control
              type="file"
              name="driversLicenseBackFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("driversLicenseBackFile", file);
              }}
              isInvalid={Boolean(touched.driversLicenseBackFile && errors.driversLicenseBackFile)}
            />
            {!!touched.driversLicenseBackFile && (
              <Form.Control.Feedback type="invalid">
                {errors.driversLicenseBackFile}
              </Form.Control.Feedback>
            )}
            <br />
            <Form.Label style={{fontSize: "0.9em"}}>Expiration Date*</Form.Label>
            <Form.Control
              type="date"
              {...getFieldProps("driversLicenseExpirationDate")} 
              isInvalid={Boolean(touched.driversLicenseExpirationDate && errors.driversLicenseExpirationDate)}
            />
            {!!touched.driversLicenseExpirationDate && (
            <Form.Control.Feedback type="invalid">
              {errors.driversLicenseExpirationDate}
            </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          {(!hideOptionalDocumentFields || cvRequired) &&
          <>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>CV / Resume{cvRequired && "*"}</Form.Label>
            <br />
            {values.cvFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.cvFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("cvFilename")}
            />
            <Form.Control
              type="file"
              name="cvFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("cvFile", file);
              }}
              isInvalid={Boolean(touched.cvFile && errors.cvFile)}
            />
            {!!touched.cvFile && (
              <Form.Control.Feedback type="invalid">
                {errors.cvFile}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          </>
          }
          {(!hideOptionalDocumentFields || colorPhotoRequired) &&
          <>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Color Photo{colorPhotoRequired && "*"}</Form.Label>
            <br />
            {values.colorPhotoFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.colorPhotoFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("colorPhotoFilename")}
            />
            <Form.Control
              type="file"
              accept="image/*,application/pdf"
              name="colorPhotoFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("colorPhotoFile", file);
              }}
              isInvalid={Boolean(touched.colorPhotoFile && errors.colorPhotoFile)}
            />
            {!!touched.colorPhotoFile && (
              <Form.Control.Feedback type="invalid">
                {errors.colorPhotoFile}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          </>
          }
          {(!hideOptionalDocumentFields || aclsRequired) &&
          <>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>ACLS{aclsRequired && "*"}</Form.Label>
            <br />
            {values.aclsFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.aclsFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("aclsFilename")}
            />
            <Form.Control
              type="file"
              name="aclsFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("aclsFile", file);
              }}
              isInvalid={Boolean(touched.aclsFile && errors.aclsFile)}
            />
            {!!touched.aclsFile && (
              <Form.Control.Feedback type="invalid">
                {errors.aclsFile}
              </Form.Control.Feedback>
            )}
            <br />
            <Form.Label style={{fontSize: "0.9em"}}>Expiration Date</Form.Label>
            <Form.Control
              type="date"
              {...getFieldProps("aclsExpirationDate")} 
              isInvalid={Boolean(touched.aclsExpirationDate && errors.aclsExpirationDate)}
            />
            {!!touched.aclsExpirationDate && (
            <Form.Control.Feedback type="invalid">
              {errors.aclsExpirationDate}
            </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          </>
          }
          {(!hideOptionalDocumentFields || pastHospitalPrivilegesDocumentRequired) &&
          <>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Hospital Privileges{pastHospitalPrivilegesDocumentRequired && "*"}
            <br /><span style={{fontSize: '0.9em', fontWeight: "normal"}}><Flag style={{height: "16px", width: "16px", color: "#2B7A78"}} /> Include both current and past affiliations, with dates</span>
            </Form.Label>
            <br />
            {values.pastHospitalPrivilegesDocumentFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.pastHospitalPrivilegesDocumentFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("pastHospitalPrivilegesDocumentFilename")}
            />
            <Form.Control
              type="file"
              name="pastHospitalPrivilegesDocumentFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("pastHospitalPrivilegesDocumentFile", file);
              }}
              isInvalid={Boolean(touched.pastHospitalPrivilegesDocumentFile && errors.pastHospitalPrivilegesDocumentFile)}
            />
            {!!touched.pastHospitalPrivilegesDocumentFile && (
              <Form.Control.Feedback type="invalid">
                {errors.pastHospitalPrivilegesDocumentFile}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          </>
          }
          {!hideOptionalDocumentFields &&
          <>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>BLS
            <br /><span style={{fontSize: '0.9em', fontWeight: "normal"}}><Flag style={{height: "16px", width: "16px", color: "#2B7A78"}} /> APPs only</span>
            </Form.Label>
            <br />
            {values.blsFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.blsFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("blsFilename")}
            />
            <Form.Control
              type="file"
              name="blsFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("blsFile", file);
              }}
              isInvalid={Boolean(touched.blsFile && errors.blsFile)}
            />
            {!!touched.blsFile && (
              <Form.Control.Feedback type="invalid">
                {errors.blsFile}
              </Form.Control.Feedback>
            )}
            <br />
            <Form.Label style={{fontSize: "0.9em"}}>Expiration Date</Form.Label>
            <Form.Control
              type="date"
              {...getFieldProps("blsExpirationDate")} 
              isInvalid={Boolean(touched.blsExpirationDate && errors.blsExpirationDate)}
            />
            {!!touched.blsExpirationDate && (
            <Form.Control.Feedback type="invalid">
              {errors.blsExpirationDate}
            </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          </>
          }
          {!hideOptionalDocumentFields &&
          <>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>PALS</Form.Label>
            <br />
            {values.palsFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.palsFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("palsFilename")}
            />
            <Form.Control
              type="file"
              name="palsFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("palsFile", file);
              }}
              isInvalid={Boolean(touched.palsFile && errors.palsFile)}
            />
            {!!touched.palsFile && (
              <Form.Control.Feedback type="invalid">
                {errors.palsFile}
              </Form.Control.Feedback>
            )}
            <br />
            <Form.Label style={{fontSize: "0.9em"}}>Expiration Date</Form.Label>
            <Form.Control
              type="date"
              {...getFieldProps("palsExpirationDate")} 
              isInvalid={Boolean(touched.palsExpirationDate && errors.palsExpirationDate)}
            />
            {!!touched.palsExpirationDate && (
            <Form.Control.Feedback type="invalid">
              {errors.palsExpirationDate}
            </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          </>
          }
          {!hideOptionalDocumentFields &&
          <>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>CDS</Form.Label>
            <br />
            {values.cdsFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.cdsFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("cdsFilename")}
            />
            <Form.Control
              type="file"
              name="cdsFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("cdsFile", file);
              }}
              isInvalid={Boolean(touched.cdsFile && errors.cdsFile)}
            />
            {!!touched.cdsFile && (
              <Form.Control.Feedback type="invalid">
                {errors.cdsFile}
              </Form.Control.Feedback>
            )}
            <br />
            <Form.Label style={{fontSize: "0.9em"}}>Expiration Date</Form.Label>
            <Form.Control
              type="date"
              {...getFieldProps("cdsExpirationDate")} 
              isInvalid={Boolean(touched.cdsExpirationDate && errors.cdsExpirationDate)}
            />
            {!!touched.cdsExpirationDate && (
            <Form.Control.Feedback type="invalid">
              {errors.cdsExpirationDate}
            </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          </>
          }
          {!hideOptionalDocumentFields &&
          <>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>ECFMG Certificate
            <br /><span style={{fontSize: '0.9em', fontWeight: "normal"}}><Flag style={{height: "16px", width: "16px", color: "#2B7A78"}} /> If foreign medical graduate</span>
            </Form.Label>
            <br />
            {values.ecfmgFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.ecfmgFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("ecfmgFilename")}
            />
            <Form.Control
              type="file"
              name="ecfmgFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("ecfmgFile", file);
              }}
              isInvalid={Boolean(touched.ecfmgFile && errors.ecfmgFile)}
            />
            {!!touched.ecfmgFile && (
              <Form.Control.Feedback type="invalid">
                {errors.ecfmgFile}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          </>
          }
          {!hideOptionalDocumentFields &&
          <>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>CME Log and/or Certificates
            <br /><span style={{fontSize: '0.9em', fontWeight: "normal"}}><Flag style={{height: "16px", width: "16px", color: "#2B7A78"}} /> Required if more than one year past graduation</span>
            </Form.Label>
            <br />
            {values.cmeFilenames && values.cmeFilenames.length > 0 &&
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.cmeFilenames.join(", ")}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("cmeFilenames")}
            />
            <Form.Control
              multiple
              type="file"
              name="cmeFiles"
              onBlur={handleBlur}
              onChange={(event) => {
                setFieldValue("cmeFiles", event.currentTarget.files);
              }}
              isInvalid={Boolean(touched.cmeFiles && errors.cmeFiles)}
            />
            {!!touched.cmeFiles && (
              <Form.Control.Feedback type="invalid">
                {errors.cmeFiles}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          </>
          }
          {!hideOptionalDocumentFields &&
          <>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Other Certifications</Form.Label>
            <br />
            {values.otherCertificationsFilenames && values.otherCertificationsFilenames.length > 0 &&
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.otherCertificationsFilenames.join(", ")}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("otherCertificationsFilenames")}
            />
            <Form.Control
              multiple
              type="file"
              name="otherCertificationsFiles"
              onBlur={handleBlur}
              onChange={(event) => {
                setFieldValue("otherCertificationsFiles", event.currentTarget.files);
              }}
              isInvalid={Boolean(touched.otherCertificationsFiles && errors.otherCertificationsFiles)}
            />
            {!!touched.otherCertificationsFiles && (
              <Form.Control.Feedback type="invalid">
                {errors.otherCertificationsFiles}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          </>
          }
          {isSubmitting ?
          <div className="text-center">
             <br />
            <Spinner size="sm" animation="border" />
          </div>
          :
          <>
          <div className="text-center mt-3 float-start">
            <Button size="lg" className="btn-secondary" onClick={() => {window.location = "/onboarding/" + onboardingStages[onboardingStages.indexOf(stage) - 1] + "/" + token}}>Back</Button>
          </div>
          <div id="submitButton" className="text-center mt-3 float-end">
            <Button
              type="submit"
              variant="primary"
              size="lg"
              disabled={isSubmitting}
            >
              Save and Continue
            </Button>
          </div>
          </>
          }
          <br /><br /><br />
          {
            Object.keys(errors).length > 0 && Object.keys(touched).length > 0 &&
            <div className="text-center mt-3"><span className="invalid-feedback" style={{display: "inline-block"}}>Please correct the errors above before completing the submission</span></div>
          }
        </Form>
      )}
    </Formik>
  );
}

export default OnboardingDocuments;
